/**
 * getErroredSections - Computes which form sections have validation errors
 *
 * Creates a map of section names to boolean indicating if that section
 * contains any invalid fields. Used to highlight errored sections in
 * mobile filter views.
 *
 * @param {Object} params - Parameters
 * @param {Object} params.categories - Search categories object (e.g., SEARCH_CATEGORIES)
 * @param {Object} params.fieldsConfig - Field configuration object (e.g., SEARCH_FIELDS)
 * @param {boolean} params.hasSubmitError - Whether form has been submitted with errors
 * @param {Object} params.validationFields - Validation result with invalidFields array
 * @returns {Object} Map of category name to boolean (true if errored)
 */
const getErroredSections = ({ categories, fieldsConfig, hasSubmitError, validationFields }) => {
  // Default: all sections not errored
  const defaultSections = Object.fromEntries(
    Object.values(categories).map((categoryName) => [categoryName, false])
  );

  if (!hasSubmitError) {
    return defaultSections;
  }

  return Object.fromEntries(
    Object.values(categories).map((categoryName) => {
      const sectionFieldNames = Object.values(fieldsConfig)
        .filter((fieldConfig) => fieldConfig.SECTION === categoryName)
        .map((fieldConfig) => fieldConfig.NAME);

      const errored = validationFields.invalidFields.some(({ name }) =>
        sectionFieldNames.includes(name)
      );

      return [categoryName, errored];
    })
  );
};

export default getErroredSections;
